import React, { useState, useEffect, useRef } from "react";

export default function DynamicReactContent() {
  const [content, setContent] = useState(<DefaultComponent />);
  const [activeButton, setActiveButton] = useState(0);
  const [isLooping, setIsLooping] = useState(false);
  const buttonContainerRef = useRef(null); // Reference to the button container

  const components = [
    <DefaultComponent />,
    <ComponentOne />,
    <ComponentTwo />,
    <ComponentThree />,
    <ComponentFour />,
  ];

  const buttonConfig = [
    { label: "Yarn sourcing and Knitting", icon: "/YarnSource.svg" },
    { label: "Fabric Dyeing and Processing", icon: "/Processing.svg" },
    { label: "Printing and Garment Finishing", icon: "/Finishing.svg" },
    { label: "Customised Packaging", icon: "/Packing.svg" },
    { label: "Global Shipping", icon: "/Shipping.svg" },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        // Toggle looping based on whether the button div is intersecting (visible)
        setIsLooping(entry.isIntersecting);
      },
      {
        root: null, // Default to viewport
        rootMargin: "0px",
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      }
    );

    if (buttonContainerRef.current) {
      observer.observe(buttonContainerRef.current);
    }

    return () => {
      if (buttonContainerRef.current) {
        observer.unobserve(buttonContainerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (isLooping) {
      interval = setInterval(() => {
        const nextButton = (activeButton + 1) % components.length;
        setActiveButton(nextButton);
        setContent(components[nextButton]);
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [activeButton, isLooping]);

  const handleButtonClick = (index) => {
    setContent(components[index]);
    setActiveButton(index);
    setIsLooping(false);
  };

  return (
    <div className="h-[78vh] w-full flex flex-col items-center justify-center mb-6 mt-[65px] ">
      <div className="flex-1 w-full flex items-center justify-center">
        {content}
      </div>

      <div
        ref={buttonContainerRef}
        className="w-[80%] p-6 flex justify-between rounded-xl -mt-20 space-x-2 bg-white"
      >
        {/* {buttonConfig.map((config, index) => (
          <button
            key={index}
            onClick={() => handleButtonClick(index)}
            className={`px-4 py-2 flex flex-col items-center justify-center text-black ${
              index === activeButton ? "bg-blue-500 rounded-xl" : "bg-white"
            }`}
          >
            <img src={config.icon} alt={config.label} className="w-12 h-12" />
            <span className="mt-2 text-sm text-gray-800">{config.label}</span>
          </button>
        ))} */}
        {buttonConfig.map((config, index) => (
          <button
            key={index}
            onClick={() => handleButtonClick(index)}
            className="px-4 py-2 flex flex-col items-center justify-center text-black bg-white"
          >
            <img
              src={config.icon}
              alt={config.label}
              className={`w-12 h-12 transition-colors duration-200 ${
                index === activeButton ? "text-485D84" : "text-gray-400"
              }`}
              style={{
                filter:
                  index === activeButton
                    ? "brightness(0) saturate(100%) invert(23%) sepia(24%) saturate(2390%) hue-rotate(196deg) brightness(93%) contrast(85%)"
                    : "",
              }}
            />
            <span
              className={`mt-2 text-sm ${
                index === activeButton ? "text-[#485D84]" : "text-gray-800"
              } transition-colors duration-200`}
            >
              {config.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

function DefaultComponent() {
  return (
    <div
      className="h-full w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/ImageSlider/Background.png)`,
      }}
    ></div>
  );
}

function ComponentOne() {
  return (
    <div
      className="h-full w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/ImageSlider/Background2.png)`,
      }}
    ></div>
  );
}

function ComponentTwo() {
  return (
    <div
      className="h-full w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/ImageSlider/Background3.png)`,
      }}
    ></div>
  );
}

function ComponentThree() {
  return (
    <div
      className="h-full w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/ImageSlider/Background4.png)`,
      }}
    ></div>
  );
}

function ComponentFour() {
  return (
    <div
      className="h-full w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/ImageSlider/Background5.png)`,
      }}
    ></div>
  );
}
